export default "__VITE_ASSET__CVwC$GeV__"